// Temporary, as it appears you are unable to load graphql files in .ts files. May be fixable with config changes.
import typeDefs from "./schema-client.graphql"

export default typeDefs
